const CardCurve = ({ color }) => (
  <svg className="card-curve" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 213">
    <path className={`bg-fill-${color}`} fillRule="evenodd" d="M199.994 4.302c.224 12.06-5.401 25.646-21.011 40.345-28.865 27.385 23.407 79.624 4.59 115.31-15.429 29.355-59.045-1.5-122.344-8.253C22.806 147.624 0 168 0 168v45h200c-.43-162.026-.432-231.592-.006-208.698Z"/>
  </svg>
);

export default CardCurve;
